import React from 'react'
import { Link } from 'gatsby'
import styled from 'react-emotion'

import { spacers } from '../theme'


const Wrapper = styled('div')`
	display: flex;
	margin: ${spacers['4']} 0;
	justify-content: space-between;
	svg {
		color: #c9c9c9;
		display: block;
		height: 48px;
		padding: 0.5rem;
		width: 48px;
	}
	a>svg {
		color: #111;
		transition: color 250ms ease;
	}
	a:hover>svg {
		color: #666;
	}
`

const prevArrow = (<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.0130378 12C0.0139208 12.3405 0.086915 12.6769 0.227218 12.9872C0.36752 13.2974 0.571944 13.5745 0.827037 13.8L12.006 23.639C12.2948 23.8754 12.6641 23.9904 13.036 23.9599C13.4079 23.9294 13.7535 23.7556 13.9999 23.4753C14.2462 23.195 14.3741 22.83 14.3566 22.4572C14.3391 22.0844 14.1776 21.733 13.906 21.477L5.26904 13.877C5.23116 13.8434 5.20438 13.7991 5.19225 13.7499C5.18011 13.7007 5.18319 13.6491 5.20108 13.6017C5.21896 13.5543 5.25082 13.5135 5.29241 13.4846C5.33401 13.4557 5.3834 13.4402 5.43404 13.44L22.548 13.44C22.9299 13.44 23.2962 13.2883 23.5663 13.0182C23.8363 12.7482 23.988 12.3819 23.988 12C23.988 11.6181 23.8363 11.2518 23.5663 10.9818C23.2962 10.7117 22.9299 10.56 22.548 10.56L5.43704 10.56C5.38642 10.5595 5.33713 10.5437 5.29565 10.5147C5.25416 10.4857 5.22241 10.4449 5.20457 10.3975C5.18672 10.3501 5.18362 10.2985 5.19566 10.2493C5.2077 10.2001 5.23432 10.1558 5.27204 10.122L13.909 2.52199C14.0601 2.39999 14.1849 2.2487 14.276 2.07721C14.3671 1.90573 14.4225 1.7176 14.439 1.52413C14.4555 1.33067 14.4327 1.13586 14.372 0.951432C14.3113 0.767003 14.2139 0.596759 14.0857 0.450938C13.9575 0.305118 13.8011 0.18673 13.6259 0.102899C13.4508 0.0190668 13.2605 -0.0284815 13.0665 -0.0368834C12.8725 -0.0452852 12.6789 -0.0143671 12.4971 0.0540075C12.3154 0.122382 12.1494 0.226806 12.009 0.360995L0.828037 10.2C0.572664 10.4254 0.367982 10.7023 0.227498 11.0126C0.0870143 11.3229 0.013919 11.6594 0.0130378 12Z' fill='currentColor' /></svg>)
const nextArrow = (<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M23.987 12C23.9861 11.6595 23.9131 11.3231 23.7728 11.0128C23.6325 10.7026 23.4281 10.4255 23.173 10.2L11.994 0.361003C11.7052 0.124613 11.3359 0.00956049 10.964 0.0400943C10.5921 0.0706281 10.2465 0.244363 10.0001 0.524684C9.7538 0.805005 9.6259 1.17002 9.6434 1.54279C9.6609 1.91557 9.82243 2.26699 10.094 2.523L18.731 10.123C18.7688 10.1566 18.7956 10.2009 18.8078 10.2501C18.8199 10.2993 18.8168 10.3509 18.7989 10.3983C18.781 10.4457 18.7492 10.4865 18.7076 10.5154C18.666 10.5443 18.6166 10.5598 18.566 10.56H1.45196C1.07005 10.56 0.703781 10.7117 0.433729 10.9818C0.163677 11.2518 0.0119629 11.6181 0.0119629 12C0.0119629 12.3819 0.163677 12.7482 0.433729 13.0182C0.703781 13.2883 1.07005 13.44 1.45196 13.44H18.563C18.6136 13.4405 18.6629 13.4563 18.7044 13.4853C18.7458 13.5143 18.7776 13.5551 18.7954 13.6025C18.8133 13.6499 18.8164 13.7015 18.8043 13.7507C18.7923 13.7999 18.7657 13.8442 18.728 13.878L10.091 21.478C9.93991 21.6 9.8151 21.7513 9.72402 21.9228C9.63294 22.0943 9.57749 22.2824 9.56099 22.4759C9.54449 22.6693 9.56728 22.8641 9.62801 23.0486C9.68873 23.233 9.78613 23.4032 9.91434 23.5491C10.0425 23.6949 10.1989 23.8133 10.3741 23.8971C10.5492 23.9809 10.7395 24.0285 10.9335 24.0369C11.1275 24.0453 11.3211 24.0144 11.5029 23.946C11.6846 23.8776 11.8506 23.7732 11.991 23.639L23.172 13.8C23.4273 13.5746 23.632 13.2977 23.7725 12.9874C23.913 12.6771 23.9861 12.3406 23.987 12Z' fill='currentColor' /></svg>)

const Navigation = ({ next, prev }) => (
	<Wrapper>
		{prev ? (
			<Link to={prev}>
				{prevArrow}
				<span className="sr-only">Previous Question</span>
			</Link>
		) : ( prevArrow )}
		{next ? (
			<Link to={next}>
				{nextArrow}
				<span className="sr-only">Next Question</span>
			</Link>
		) : ( nextArrow )}
	</Wrapper>
)

export default Navigation
